var _defs, _circle, _circle2, _path, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crown_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 6.333,
    r: 1.5,
    className: "crown_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 6.417,
    r: 1.5,
    className: "crown_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22h16M4 19 1.953 7.828S3 13 7 13s5-7 5-7 1 7 5 7 5.047-5.093 5.047-5.093L20 19Z",
    className: "crown_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2,
    className: "crown_svg__a"
  })));
};
export default SvgCrown;